const Purchases = {
  init() {
    if ($('#card-element').length !== 1) return;

    this.stripe = Stripe($('#card-element').data('public-payment-key'));
    this.card = this.stripe.elements().create('card', { style: this.style });
    this.card.mount('#card-element');

    this.card.addEventListener('change', this.onCardChange);

    document.getElementById('purchase-form')
            .addEventListener('submit', this.onUserFormSubmit.bind(this));
  },

  onCardChange(event) {
    const displayError = $('#card-errors');
    if (event.error) {
      $('#card-errors').html(event.error.message);
    } else {
       $('#card-errors').html('');
    }
  },

  onUserFormSubmit(event) {
    $('#submitter').hide();
    event.preventDefault();

    this.stripe.createToken(this.card).then((result) => {
      if (result.error) {
        $('#submitter').show();
        var errorElement = $('#card-errors').html(result.error.message);
      } else {
        this.completeSubmission(result.token);
      }
    });
  },

  completeSubmission(tokenObject) {
    $('#token-holder').val(tokenObject.id);
    document.getElementById('purchase-form').submit();
  },

  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  }

}

$(document).ready(()=> {
  Purchases.init();
});
